const React = require("react");
const PropTypes = require("prop-types");

const OptionsBox = ({
  title, children, style, className,
}) => {
  return (
    <div className={`b-options-box ${className}`} style={style}>
      <div className="b-options-box__title">{title}</div>
      <div className="b-options-box__content">
        {children}
      </div>
    </div>
  );
};

OptionsBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

OptionsBox.defaultProps = {
  style: null,
  className: "",
};

module.exports = OptionsBox;
